import { Footer } from "../../components";

export const FooterPages = () => {
  return (
    <>
      <Footer />
    </>
  );
};
